export default "__VITE_ASSET__tpe0Gja2__"